<template>
  <div class="account-under-link-list">
    <Card class="mb-10" :bordered="false" :dis-hover="true">
      <div class="mb-10 font-size-14">
        基础框下链接为起飞投放端提供的在稿件框下设置广告链接的能力，该链接将在自然流量带来的播放中展出。<br/>
        基础框下链接与稿件绑定。满足以下条件的稿件可以绑定基础框下链接：①为商单稿件；②未设置邀约框下链接；③本账户范围内未关联其他基础框下链接。<br/>
        <span class="font-weight-600">当所在稿件对应计划包含至少一个优化目标为“框下链接点击”的单元，且该单元下有至少一个在投创意时，该基础框下链接才会被展出。
          基础框下链接非必须设置。未设置邀约框下链接且未设置基础框下链接的稿件在自然流量场景下将无框下链接展出。</span>
        详细规则请查看<span class="link c-007CFF" @click="onShowUnderLinkDesc">《框下链接优化说明》</span>
      </div>
    </Card>
    <div class="content-panel border-radius-4px bg-FFFFFF">
      <div class="btn-bar">
        <Button type="primary" icon="md-add" @click="addUnderLink">新建基础框下链接</Button>
      </div>
      <Grid class="kic-table kic-page" ref="grid" :table-option="tableOption">
        <template v-slot:image="{ slotProps: { row } }">
          <ImageCard :row="row"/>
        </template>
        <template v-slot:button="{ slotProps: { row } }">
          <Button type="primary" @click="onEdit(row)">编辑</Button>
          <Button type="error" class="ml-10" @click="onDelete(row)">删除</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { PAGE_SIZE, URLS } from '@/constants'
import Emitter from '@/mixins/emitter'
import ImageCard from './component/ImageCard.vue'
import Desc from './component/Desc.vue'

const COMPONENT_NAME = 'AccountUnderLinkList'
export default {
  name: COMPONENT_NAME,
  mixins: [Emitter],
  components: {
    ImageCard
  },
  data () {
    return {
      tableOption: {
        url: URLS.QUERY_BASIC_UNDER_LIST,
        columns: [
          {
            title: '基础框下链接ID',
            align: 'center',
            key: 'id'
          },
          {
            title: '素材图片',
            align: 'center',
            width: '400',
            slot: 'image',
            key: 'rate'
          },
          {
            title: '关联稿件BVID',
            align: 'center',
            key: 'bvid'
          },
          {
            title: '关联稿件标题',
            align: 'center',
            key: 'title'
          },
          {
            title: '审核状态',
            align: 'center',
            key: 'audit_status_desc'
          },
          {
            title: '操作',
            align: 'center',
            slot: 'button',
            key: 'id'
          }
        ],
        params: {
          page: 1,
          size: PAGE_SIZE
        }
      }
    }
  },
  methods: {
    addUnderLink () {
      this.$router.push({
        name: 'AddUnderLink'
      })
    },
    jumpToEdit (row) {
      this.$router.push({
        name: 'EditUnderLink',
        params: {
          id: row.id
        }
      })
    },
    // 删除绑定信息
    onDelete (row) {
      this.confirmInfo({
        title: '删除基础框下链接',
        content: `您确认删除该基础框下链接: ${row.title}？`
      }).then(() => {
        this.$http.delete(URLS.REMOVE_BASIC_UNDER.replace('{id}', row.id)).then(res => {
          this.$Message.success('删除基础框下链接成功!')
          this.onRefreshList()
        }, () => {
          this.$Message.error('删除基础框下链接失败!')
        })
      })
    },
    onEdit (row) {
      this.$router.push({
        name: 'EditUnderLink',
        params: {
          id: row.id
        }
      })
    },
    onRefreshList () {
      this.broadcast('Grid', 'on-reset-grid-all')
    },
    onShowUnderLinkDesc () {
      this.$Modals.open(Desc, {
        title: '框下链接优化说明',
        modalProps: {
          width: 860,
          'footer-hide': true
        }
      }).then(() => {}, () => {})
    }
  }
}
</script>
<style lang="less">
.account-under-link-list {
  .btn-bar {
    padding: 20px 20px 12px 20px;
  }

  .link {
    cursor: pointer;
  }

  .content-panel {
    min-height: 300px;
  }
}
</style>
